import { Box } from '@chakra-ui/react';

export function Divider({ isCollapsed, ...styles }) {
  return <Box {...styles} />;
}
